"use client";

import { ReactNode } from "react";
import NextForm from "next/form";
import { useNotifyDialog } from "../Providers/NotifyDialogContext";
import { updateNotificationSettingsAction } from "../actions";

interface FormProps {
  children: ReactNode;
}

export default function Form({ children }: FormProps) {
  const { campaignIdsToNotify, closeNotificationsDialog } = useNotifyDialog();

  const handleAction = async (formData: FormData) => {
    const result = await updateNotificationSettingsAction(formData);
    if (result.success) {
      closeNotificationsDialog();
    } else {
      console.error("Error updating notification settings:", result.error);
    }
  };

  return (
    <NextForm action={handleAction}>
      {campaignIdsToNotify.map((id) => (
        <input key={id} type="hidden" name="ids" value={id} />
      ))}
      {children}
    </NextForm>
  );
}
